import { ComponentColors } from '@/enums'
import { LeftArrow } from '@/icons'
import { useGoBack } from '@/utils'
import { ButtonLink, ButtonLinkProps } from '../ButtonLink'
import { Container } from './styles'
import { useTranslation } from 'react-i18next'

interface BackComponentProps extends Omit<ButtonLinkProps, 'children'> {
  onBack?: () => void
  noContentGutter?: boolean
  noMargin?: boolean
}

export const BackComponent = ({
  onBack,
  noContentGutter,
  noMargin,
}: BackComponentProps) => {
  const { t } = useTranslation()
  const goBack = useGoBack()

  return (
    <Container noContentGutter={noContentGutter} noMargin={noMargin}>
      <ButtonLink
        color={ComponentColors.primary}
        icon={LeftArrow}
        onClick={onBack || goBack}
      >
        {t('common.back')}
      </ButtonLink>
    </Container>
  )
}
